export default "__VITE_ASSET__CtWZWcIb__"